import { Table } from '@tanstack/react-table';
import { DATA_TABLE_PAGE_SIZES } from '@repo/atomic-components';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';

interface SizeControlProps<T = unknown> {
  pageSize: number;
  selectId: string;
  selectRef: React.RefObject<HTMLSelectElement>;
  table: Table<T>;
  textClassName?: string;
  /** Extra classes for the Dropdown root. */
  dropdownClassName?: string;
  /** Classes for the selected value; `!important` ones win over the default grey. */
  valueClassName?: string;
}

export const SizeControl = <T,>({
  pageSize,
  table,
  textClassName,
  dropdownClassName,
  valueClassName = '!text-theme-text-grey',
}: SizeControlProps<T>) => {
  const handlePageSizeChange = (value: number) => {
    table.setPageSize(value);
  };

  const options = DATA_TABLE_PAGE_SIZES.map((size) => ({
    label: String(size),
    value: size,
  }));

  return (
    <div className="flex shrink-0 items-center gap-2">
      <span className={classNames('text-[0.75rem] leading-5 font-[400]', textClassName ?? 'text-black', 'select-none')}>
        Show
      </span>
      <Dropdown
        value={pageSize}
        options={options}
        ariaLabel="Select Results per page"
        aria-label="Select Results per page"
        onChange={(e) => handlePageSizeChange(e.value)}
        className={classNames(
          'h-8 w-20 [&_.p-dropdown-trigger]:!w-8',
          // Not `!important`, so callers can override with `!`.
          'border-theme-border-grey [&_.p-dropdown-label]:text-[0.75rem] [&_.p-dropdown-label]:leading-5',
          dropdownClassName,
        )}
        panelClassName="[&_.p-dropdown-item]:!text-[0.75rem] [&_.p-dropdown-item]:!leading-5 [&_.p-dropdown-item]:!py-2"
        pt={{
          // Use the theme background and text colour instead of PrimeReact's white.
          root: {
            className: '!border !bg-transparent [&_.p-dropdown-label]:!bg-transparent [&_.p-inputtext]:!bg-transparent',
          },
          input: { className: classNames('!bg-transparent', valueClassName) },
        }}
      />
    </div>
  );
};
